import { createTrackUiEvents } from '@bluecodecom/tracking';

import { TrackingEvents, trackingService } from '../service';
import { PayAtPumpUiVocabulary } from './trackUi.types';

/**
 * Reports an interaction twice — the catalogued universal event and this app's
 * legacy one — for as long as the migration needs both (catalog rule
 * `dual-fire`).
 *
 * `screen_name` is filled in from the last displayed screen rather than passed
 * at the call site; see `screenContext` in `libs/tracking`.
 */
const trackUi = createTrackUiEvents<PayAtPumpUiVocabulary, TrackingEvents>(
  trackingService,
);

export default trackUi;
